module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "chatroom"
    }
  }, [(_vm.isLoggedIn && !_vm.selectedHistoryDate && !_vm.showingHistoryDates) ? _c('div', {
    attrs: {
      "id": "chatroom-room-selector"
    }
  }, [_c('label', {
    attrs: {
      "for": "room-selector-input"
    }
  }, [_vm._v("Room: ")]), _vm._v(" "), _c('select', {
    attrs: {
      "id": "room-selector-input"
    },
    on: {
      "change": _vm.chooseNewRoom
    }
  }, _vm._l((_vm.rooms), function(room) {
    return _c('option', {
      domProps: {
        "value": room.id,
        "selected": _vm.selectedRoom.id === room.id
      }
    }, [_vm._v(_vm._s(room.name))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showingHistoryDates) ? [_c('ul', {
    attrs: {
      "id": "chatroom-history-dates"
    }
  }, [(_vm.showHistoryDatesLoader || _vm.showHistoryMessagesLoader) ? _c('li', {
    staticClass: "loader-container"
  }, [_c('loader-small')], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.historyDates), function(historyDate) {
    return (!_vm.showHistoryMessagesLoader && !_vm.showHistoryMessagesLoader) ? _c('li', {
      staticClass: "history-date-item",
      on: {
        "click": function($event) {
          _vm.selectHistoryDate(historyDate)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(historyDate.messageCount))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDateWithoutTime")(historyDate.day)))])]) : _vm._e()
  })], 2)] : _vm._e(), _vm._v(" "), (!_vm.showingHistoryDates) ? [(_vm.selectedHistoryDate) ? _c('span', {
    attrs: {
      "id": "chatroom-history-header"
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-arrow-left",
    on: {
      "click": _vm.showHistoryDates
    }
  }), _vm._v("\n                History: " + _vm._s(_vm._f("formatDateWithoutTime")(_vm.selectedHistoryDate.day)) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    ref: "chatMessages",
    attrs: {
      "id": "chatroom-messages"
    }
  }, [(_vm.showHistoryMessagesLoader) ? _c('li', {
    staticClass: "loader-container"
  }, [_c('loader-small')], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.messages), function(message) {
    return _c('li', [(!message.isSystemMessage) ? _c('div', {
      staticClass: "avatar-container"
    }, [_c('avatar', {
      attrs: {
        "profile-data": message.from,
        "profile-type": "developer",
        "size": "very-small",
        "show-xp-info": false
      }
    })], 1) : _vm._e(), _vm._v(" "), (!message.isSystemMessage) ? _c('div', {
      staticClass: "message-details"
    }, [_c('span', {
      staticClass: "message-from"
    }, [_c('router-link', {
      attrs: {
        "to": '/Developer/' + message.from.stringUrl
      }
    }, [(message.from.isModerator) ? _c('i', {
      staticClass: "fas fa-crown mod-icon"
    }) : _vm._e(), _vm._v(" "), (message.from.donatedAmount > 0 && message.from.donatedAmount < 40) ? _c('i', {
      staticClass: "fas fa-heartbeat donor-icon"
    }) : _vm._e(), _vm._v(" "), (message.from.donatedAmount >= 40) ? _c('i', {
      staticClass: "fas fa-heartbeat donor-icon gold"
    }) : _vm._e(), _vm._v("\n                                        " + _vm._s(message.from.alias) + "\n                                    ")])], 1), _vm._v(" "), _vm._l((message.messages), function(individualMessage) {
      return _c('div', {
        staticClass: "individual-message"
      }, [_c('markdown-content', {
        attrs: {
          "classes": "message-message",
          "content": individualMessage.message
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "message-date"
      }, [_vm._v(_vm._s(_vm._f("formatDateCondensed")(individualMessage.timestamp)))])], 1)
    })], 2) : _vm._e(), _vm._v(" "), (message.isSystemMessage) ? _c('div', {
      staticClass: "message-details"
    }, _vm._l((message.messages), function(individualMessage) {
      return (message.isSystemMessage) ? _c('div', {
        staticClass: "individual-message"
      }, [(message.systemMessageType === 'registeredDeveloper') ? _c('section', {
        staticClass: "message-message system-message"
      }, [_c('i', {
        staticClass: "fas fa-user"
      }), _vm._v(" "), _c('router-link', {
        attrs: {
          "to": message.targetUrl
        }
      }, [_vm._v(_vm._s(message.targetAlias))]), _vm._v("\n                                just registered\n                            ")], 1) : _vm._e(), _vm._v(" "), (message.systemMessageType === 'createdGame') ? _c('section', {
        staticClass: "message-message system-message"
      }, [_c('i', {
        staticClass: "fas fa-gamepad"
      }), _vm._v(" "), _c('router-link', {
        attrs: {
          "to": message.targetUrl
        }
      }, [_vm._v(_vm._s(message.targetAlias))]), _vm._v("\n                                just created\n                            ")], 1) : _vm._e(), _vm._v(" "), (message.systemMessageType === 'message') ? _c('section', {
        staticClass: "message-message system-message"
      }, [_c('markdown-content', {
        attrs: {
          "classes": "message-message",
          "content": individualMessage.message
        }
      })], 1) : _vm._e()]) : _vm._e()
    })) : _vm._e()])
  })], 2)] : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chatroom-options"
    }
  }, [_c('div', {
    class: ['option', {
      selected: _vm.showingHistoryDates || _vm.showingHistoryDateMessages
    }],
    attrs: {
      "title": "History"
    },
    on: {
      "click": _vm.toggleHistoryDates
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-history"
  })]), _vm._v(" "), (_vm.audioNotificationsEnabled) ? _c('div', {
    staticClass: "option",
    attrs: {
      "title": "Turn off Audio Notifications"
    },
    on: {
      "click": function($event) {
        _vm.toggleAudioNotifications('off')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-volume-up"
  })]) : _vm._e(), _vm._v(" "), (!_vm.audioNotificationsEnabled) ? _c('div', {
    staticClass: "option",
    attrs: {
      "title": "Turn on Audio Notifications"
    },
    on: {
      "click": function($event) {
        _vm.toggleAudioNotifications('on')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-volume-off"
  })]) : _vm._e()]), _vm._v(" "), (_vm.isLoggedIn && !_vm.selectedHistoryDate && !_vm.showingHistoryDates) ? _c('form', {
    attrs: {
      "id": "chatroom-input"
    }
  }, [(_vm.isLoggedIn) ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMessage),
      expression: "newMessage"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Type to chat...",
      "maxlength": "450"
    },
    domProps: {
      "value": (_vm.newMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Send"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendMessage($event)
      }
    }
  })] : _vm._e()], 2) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-88513b28!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/ChatRoom/ChatRoom.vue
// module id = 899
// module chunks = 2